module.exports = __webpack_public_path__ + "img/logo.47b2a8eb.png";